'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './proxy-holder-property-select.routes';

export class ProxyHolderPropertySelectComponent {
  constructor(Auth, DTOptionsBuilder, dialogs, $uibModal, $window, $stateParams, VotingsService, $state, User,
              SettingsService, PropertyService, VoterGroupsService) {
    'ngInject';

    this.$state = $state;

    this.voteId = $stateParams.voteId;
    this.ballotId = $stateParams.ballotId;
    this.proxyHolder = $stateParams.proxy;

    this.back = _ => $window.history.back();

    this.properties = [];
    this.selected = [];

    SettingsService.getByName({name: 'client'}, settings => {
      this.proxyVoteAllowed = settings.data.proxy && settings.data.proxy.canVote;
      this.useSuite = settings.data.useSuite;

      VotingsService.get({id: this.voteId}, vote => {
        this.vote = vote;
        this.ballot = this.vote.ballots.find(ballot => ballot._id = this.ballotId);

        let VG_DATA_METHOD = (this.useSuite) ? "getWithDataSuite" : "getWithData";
        VoterGroupsService[VG_DATA_METHOD]({id: this.vote.voterGroup._id}, vg => {

          vg.properties.forEach(ppty => {

              let voter = this.vote.proxies.find(v => v.property == ppty._id);
              if (voter) {

                if (!voter.proxy.enabled)
                  return;

                if (!
                    (this.proxyHolder == this.vote.defaultProxy.name && voter.proxy.type == "default")
                  || (this.proxyHolder != this.vote.defaultProxy.name && voter.proxy.writeInProxyApproved && voter.proxy.writeInProxyName == this.proxyHolder)
                )
                  return;

                this.properties.push(ppty);
              }
            })

        }, err => {
          console.log("Could not retrieve voting group.")
        });

      }, err => {
        console.log("Could not retrieve vote.")
      });

    });
  }

  castVotes() {
    this.$state.go('cast-vote-proxy',{id: this.ballotId, voteId: this.voteId, properties: this.selected, proxyName: this.proxyHolder});
  }

  markAllAsSelected() {
    this.properties.forEach(ppty => {
      if (!ppty.selected) {
        ppty.selected = true;
        this.selected.push(ppty);
      }
    })
  }

  markAsSelected(property) {
    let availableProperty = this.properties.find(ppty => ppty.lot == property.lot && property.address == ppty.address);

    if (availableProperty) {
      availableProperty.selected = true;
      this.selected.push(property);
    }
  }

  unmarkAsSelected(property) {
    let availableProperty = this.properties.find(ppty => ppty.lot == property.lot && property.address == ppty.address);

    if (availableProperty) {
      availableProperty.selected = false;
    }

    let selectedPropertyIndex = this.selected.findIndex(ppty => ppty.lot == property.lot && property.address == ppty.address);
    if (selectedPropertyIndex !== -1) {
      this.selected.splice(selectedPropertyIndex, 1);
    }
  }

}

export default angular.module('conduu.proxyHolderPropertySelect', [uiRouter])
  .config(routes)
  .component('proxyHolderPropertySelect', {
    template: require('./proxy-holder-property-select.html'),
    controller: ProxyHolderPropertySelectComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/ballot/proxy-holder-property-select/proxy-holder-property-select.component.js